import SelectOptionVuetify from '@/modules/select_option/SelectOptionVuetify'
import { translate } from '@/plugins/i18n.js'
import UtilityHelper from '@/services/helpers/UtilityHelper'

const _getIncrements = (entity) => {
  let increments
  if (entity?.qty_increments) {
    // everything else
    increments = entity.qty_increments
  } else if (entity?.qty_increments === null) {
    return []
  } else {
    // meta product
    increments = entity?.qty?.values
  }

  return increments?.map(Number) ?? []
}

const _getUnitOptionText = (qty, translation) => {
  const text = translation
    ? UtilityHelper.formatString('%s %s', qty, translation)
    : qty
  return new SelectOptionVuetify(qty, text)
}

const _prepareMetaTranslations = (text) => text.replace('%s', '')

const _getUnitTranslations = (product) => {
  if (product.qty?.text)
    return {
      singular: _prepareMetaTranslations(product.qty.text.singular),
      plural: _prepareMetaTranslations(product.qty.text.plural)
    }

  const unitType = product.unit_type
  if (unitType === 'package')
    return {
      singular: translate('fe_app_pdp_package'),
      plural: translate('fe_app_pdp_packages')
    }
  if (unitType === 'piece')
    return {
      singular: translate('pdp_attribute_slice'),
      plural: translate('pdp_attribute_slice')
    }

  return {
    singular: translate('fe_app_pdp_bottle'),
    plural: translate('fe_app_pdp_bottles')
  }
}

class SelectOptionFactory {
  static getTitleOptions() {
    return [
      new SelectOptionVuetify('dr', translate('dr')),
      new SelectOptionVuetify('dr_dr', translate('dr_dr')),
      new SelectOptionVuetify('prof', translate('prof')),
      new SelectOptionVuetify('prof_dr', translate('prof_dr')),
      new SelectOptionVuetify('prof_dr_dr', translate('prof_dr_dr'))
    ]
  }

  static getOptionText(options, value = 'key', text = 'value') {
    return options.map(
      (option) => new SelectOptionVuetify(option[value], option[text])
    )
  }

  static getQtyOptionsForProduct(
    product,
    noText = false,
    additionalOption = null
  ) {
    const unit = noText
      ? { singular: null, plural: null }
      : _getUnitTranslations(product)
    const productIncrements = _getIncrements(product)
    const qtyIncrements =
      additionalOption && !productIncrements.includes(additionalOption)
        ? [...productIncrements, additionalOption].sort((a, b) => a - b)
        : productIncrements

    return (
      qtyIncrements.map((qty) =>
        _getUnitOptionText(qty, qty === 1 ? unit.singular : unit.plural)
      ) ?? []
    )
  }

  static getSmallestQtyNumber(product) {
    const productIncrements = _getIncrements(product)
    return productIncrements.sort((a, b) => a - b)[0] ?? null
  }
}

export default SelectOptionFactory
